import React, { VFC } from 'react';
import { Container, Row, Col } from 'react-grid-system';

import styled from 'styled-components';
import SignInCustomerForm from '../components/organisms/form/SignInCustomerForm';
import SignInEmailForm from '../components/organisms/form/SignInEmailForm';
import { useAppInit } from '../contexts/appInitContext';

const Border = styled(Col)`
  border-radius: 32px;
  border: 0px solid #e0e0e0;
`;

const Section = styled(Row)`
  padding: 25vh 5vw;
`;

const LoginPage: VFC = () => {
  const { params } = useAppInit();
  const { loginType } = params;

  return (
    <Container>
      <Row>
        <Border>
          <Section justify="center">
            <Col sm={12} md={8} lg={5} xl={5}>
              <Row justify="center">
                {loginType === '0' ? (
                  <SignInEmailForm />
                ) : (
                  <SignInCustomerForm />
                )}
              </Row>
            </Col>
          </Section>
        </Border>
      </Row>
    </Container>
  );
};

export default LoginPage;
